<div class="d-md-flex align-items-center bg-white p-3">
  <a href="javascript:void(0)" class="d-flex align-items-center p-2 rounded-pill ">
    <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"></h5>
    <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{Clienti?.length}}</span>
  </a>
</div>
<div class="table-responsive">
  <table class="table bg-white table-hover align-middle mb-0 no-wrap">
    <thead>
    <tr>
      <th >Nome</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let co of Clienti">
      <td (click)='OpenMap(co)'>
        <span class="text-dark font-medium font-16">{{ co.nominativo }}</span>
      </td>
    </tr>
    </tbody>
  </table>
</div>
